<template>
  <b-container
    style="background-color:#fbf4ec; margin-bottom: 15px"
    class="p-4 container-fluid"
  >
    <b-row>
      <b-col class="col-sm-4">
        <b-img
          :src="user.imgURL"
          :alt="`${user.firstname} ${user.lastname}`"
          style="border-radius: 30px"
        >
        </b-img>
      </b-col>
      <b-col>
        <h2>Hi, I'm {{ user.firstname }} {{ user.lastname }}</h2>
        <h3>{{ user.bio }}</h3>
        <h3>Los Angeles, CA</h3>
        <h3>ponyengine.com</h3>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: "card-plan",
  components: {},
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  created() {},
  computed: {},
  methods: {},
  data() {
    return {};
  }
};
</script>
